import { useRestClient } from '@/contexts/QueryProvider'
import { getDatabricksErrorMessage } from '@/lib/databricksErrorMessage'
import { ConnectionStatus } from './ConnectionStatus'
import { toast } from 'sonner'
import { Button } from '@/components/shadcn/button'
import { TooltipButton } from '@/components/ui/TooltipButton'

export function DatabricksConnectionStatus() {
  const { getDatabricksApiGetDatabricksStatus, putDatabricksApiInitialiseDatabricks } = useRestClient()
  const { data: connectionStatus } = getDatabricksApiGetDatabricksStatus.useSuspenseQuery(undefined)

  const { mutateAsync: initialiseDatabricks, isPending: isInitialisingDatabricks } =
    putDatabricksApiInitialiseDatabricks.useMutation()

  const onInitialise = () => {
    toast.info('Please wait while Databricks is initialised')
    initialiseDatabricks(
      {},
      {
        onError: (error: unknown) => {
          toast.error('Error initialising Databricks: ' + getDatabricksErrorMessage(error))
        },
        onSuccess: () => {
          toast.success('Databricks initialisation complete')
        },
      }
    )
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-8 rounded-xl bg-foreground/5 px-8 pb-8 pt-5">
        <h3 className="pl-1 text-lg font-bold">Databricks Connection Status:</h3>
        <ConnectionStatus connectionStatus={connectionStatus.items} />
      </div>
      <div className="flex justify-end">
        <TooltipButton tooltip="Create necessary elements in Databricks">
          <Button onClick={onInitialise} disabled={isInitialisingDatabricks}>
            Initialise Databricks
          </Button>
        </TooltipButton>
      </div>
    </div>
  )
}
